import React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../theme';
const Attention = ({ className, title, description }) => {
    const { Attention: css } = useTheme('Shared');
    return (React.createElement("div", { className: cn(className, css.wrapper) },
        title && React.createElement("div", { className: css.title }, title),
        description && React.createElement("div", { className: css.text }, description)));
};
export default Attention;
